import { DealStatus } from '../../shared/entities/filters/enum/DealStatus';

export class CompanyDataService {
  static isPriced(status?: DealStatus): boolean {
    return status === DealStatus.Priced;
  }
}
